import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {AbstractVisbosControl} from "../../../core/visbos-core/ui/forms/abstract-visbos-control";
import {Manufacturer} from "../../../shared/view-model/crm/manufacturer";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {appInjector} from "../../../index";
import {AddressFormComponent} from "../../../core/visbos-core/ui/forms/address-form/address-form.component";

@Component({
  selector: 'vb-manufacturer-form',
  templateUrl: './manufacturer-form.component.html',
  styleUrls: ['./manufacturer-form.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => ManufacturerFormComponent)}]
})
export class ManufacturerFormComponent extends AbstractVisbosControl<Manufacturer, FormGroup> {

  constructor(fb?: FormBuilder, cd?: ChangeDetectorRef) {
    super(fb, cd, null);
  }

  buildControlContent(): FormGroup {
    return ManufacturerFormComponent.initControl(this.fb);
  }

  public static initControl(fb: FormBuilder = null): FormGroup {
    fb = fb ? fb : appInjector().get(FormBuilder);

    return fb.group({
      cuid: [null],
      name: [null, Validators.required],
      administration_unit_id: [null, Validators.required],
      address_name: [null],
      address: AddressFormComponent.initControl(fb)
    });

  }

  setDefaultValues(item?: Manufacturer): {[p: string]: any}|any {
    return {
      cuid: this.setValue(item, 'cuid', AbstractVisbosControl.cuid()),
      name: this.setValue(item, 'name'),
      address_name: this.setValue(item, 'address_name'),
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/crm/manufacturer/manufacturer-form/manufacturer-form.component.ts